import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../app.config';
import { MessageService } from '../core/service/message.service';
import { ProgressBarService } from '../core/service/progress-bar.service';
import { DataServiceBase } from '../core/service/base/data.service.base';
import { Observable, finalize, map } from 'rxjs';

@Injectable()
export class DebugApiService extends DataServiceBase {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, messageService, progressBar, config, 'debug');
  }

  getMappingExceptions(): Observable<any> {
    this.progressBar.start();
    return this.client.get<any>(`${this.endpoint}/mapping`).pipe(
      map(item => item), // TODO
      finalize(() => this.progressBar.stop())
    );
  }
}
